enum TsaDialogFields {
	ENABLED = "enabled",
	URL = "url",
	HASHALGORITHM = "hashalgorithm",
	USER = "user",
	PASSWORD = "password"
}

export default TsaDialogFields;